<template>
  <div class="store-links" :class="linksClass">
    <a
      v-if="showApple"
      class="store-badge"
      :href="APP_STORE_URL"
      target="_blank"
      rel="noopener noreferrer"
      title="Download on the App Store"
    >
      <span class="store-badge__inner">
        <img
          class="store-badge__img store-badge__img--apple"
          src="@/assets/site/images/new/app-store.png"
          alt="Download on the App Store"
        />
      </span>
    </a>
    <a
      v-if="showAndroid"
      class="store-badge"
      :href="GOOGLE_PLAY_URL"
      target="_blank"
      rel="noopener noreferrer"
      title="Get it on Google Play"
    >
      <span class="store-badge__inner">
        <img
          class="store-badge__img store-badge__img--android"
          src="@/assets/site/images/new/android.png"
          alt="Get it on Google Play"
        />
      </span>
    </a>
  </div>
</template>

<script>
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/constants/appStoreUrls";

export default {
  name: "AppStoreBadges",
  props: {
    showApple: {
      type: Boolean,
      default: true,
    },
    showAndroid: {
      type: Boolean,
      default: true,
    },
    linksClass: {
      type: [String, Object, Array],
      default: null,
    },
  },
  data() {
    return {
      APP_STORE_URL,
      GOOGLE_PLAY_URL,
    };
  },
};
</script>
